import { Auth } from 'aws-amplify';

const forgotPasswordSubmit = (email, code, newPassword) => {
  if (!email || !code || !newPassword) throw new Error('Some parameter is missing');
  return Auth.forgotPasswordSubmit(email.trim(), code, newPassword);
};

export default forgotPasswordSubmit;
